// extracted by mini-css-extract-plugin
export default {"pieChart":"PieChart_pieChart__T+MoM"};